import { DefaultPageHeader } from 'layouts';
import type { OrganizationList } from 'models';
import { BankLineIcon, Col, Empty, Paragraph, type RadioPillsOnChangeEvent, Row, StarLineIcon } from 'ui';
import { useTextCollapseExpand } from 'common/hooks';

type P = {
  isLoading?: boolean;
  onChange?: (value: RadioPillsOnChangeEvent) => void;
  organizations: OrganizationList[];
  value?: string;
};

const ChannelsOrganizationSelect = ({ onChange, organizations, value }: P) => {
  const selectedOrganization = value
    ? organizations.find((organizationItem) => organizationItem.id === value)
    : undefined;

  const { collapseExpandButton, ellipsis } = useTextCollapseExpand({
    text: selectedOrganization?.description,
  });

  const items = organizations.map((organization) => ({
    icon: organization.isDefault ? <StarLineIcon /> : <BankLineIcon />,
    label: organization.name,
    value: organization.id,
  }));

  return (
    <>
      {organizations.length === 0 ? (
        <Empty />
      ) : (
        <div className="channels-organization-select">
          <DefaultPageHeader
            radioPills={{
              items,
              onChange,
              value,
            }}
            title="Channels"
          />
          {selectedOrganization?.description ? (
            <Row key={selectedOrganization.description}>
              <Col span={12}>
                <Paragraph ellipsis={ellipsis}>{selectedOrganization.description}</Paragraph>
                {collapseExpandButton}
              </Col>
            </Row>
          ) : null}
        </div>
      )}
    </>
  );
};

export default ChannelsOrganizationSelect;
